import { isArrayWithValue } from '@/utils/helpers/isArrayWithValue';
import { IPillCards } from '@/utils/interfaces/bloks';
import { StoryblokComponent } from '@storyblok/react';
import { Container } from '../Shared/Layout/Container';
import { SbSection } from '../Shared/Layout/SbSection';
import { FormattedText } from '../Shared/FormattedText';

interface IProps {
  blok: IPillCards;
  preview: boolean;
}

export const PillCards: React.FC<IProps> = ({ blok, preview }) => {
  return (
    <SbSection blok={blok} preview={preview} classNames="relative py-[72px]">
      <Container align="center">
        <FormattedText className='md:text-7xl text-3xl mb-7 md:mb-14' tag="h3" text={blok.heading} />
        {isArrayWithValue(blok.pill_card) && (
          <div className="grid grid-col-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            {blok.pill_card.map((card) => (
              <StoryblokComponent blok={card} key={card._uid} />
            ))}
          </div>
        )}
      </Container>
    </SbSection>
  );
};
